import { put, call } from 'redux-saga/effects';
import * as types from '../actions'; 
import { listFieldDetails,saveFieldDetails,deleteFieldDetails,listVehicleInfo,saveVehicleInfo,deleteVehicleInfo,updateVehicleInfo,getVehicleInfo} from '../services/vehicleInfoService';

export function* listFieldDetailsSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
      	const response = yield call(listFieldDetails, payload);
      	yield put({ type: types.LIST_FIELD_DETAILS_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.LIST_FIELD_DETAILS_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* saveFieldDetailsSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(saveFieldDetails, payload);
	    yield put({ type: types.SAVE_FIELD_DETAILS_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SAVE_FIELD_DETAILS_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* deleteFieldDetailsSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(deleteFieldDetails, payload);
    yield put({ type: types.DELETE_FIELD_DETAILS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.DELETE_FIELD_DETAILS_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}


export function* listVehicleInfoSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(listVehicleInfo, payload);
	    yield put({ type: types.LIST_VEHICLE_INFO_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.LIST_VEHICLE_INFO_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* saveVehicleInfoSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(saveVehicleInfo, payload);
	    yield put({ type: types.SAVE_VEHICLE_INFO_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SAVE_VEHICLE_INFO_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* deleteVehicleInfoSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(deleteVehicleInfo, payload);
	    yield put({ type: types.DELETE_VEHICLE_INFO_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.DELETE_VEHICLE_INFO_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* updateVehicleInfoSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(updateVehicleInfo, payload);
	    yield put({ type: types.UPDATE_VEHICLE_INFO_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.UPDATE_VEHICLE_INFO_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* getVehicleInfoSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(getVehicleInfo, payload);
	    yield put({ type: types.GET_VEHICLE_INFO_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.GET_VEHICLE_INFO_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}